 
import {  Injectable } from '@angular/core';
import {  BehaviorSubject } from 'rxjs';


/**
 * ScreenSizeService is used to track and manage the screen size state.
 * It provides observables that indicate whether the screen is large or small.
 * 
 * Usage:
 * - isLargeScreen: Observable that emits true if the screen is considered large.
 * - isSmallScreen: Observable that emits true if the screen is considered small.
 */

@Injectable({
    providedIn: 'root'
  })
  export class ScreenSizeService {
  
  // Observable for large screen state
    public isLargeScreen = new BehaviorSubject<boolean>(false);
    
     // Observable for small screen state
    public isSmallScreen= new BehaviorSubject<boolean>(false);

    // Observable for mobile state
    public isMobile = new BehaviorSubject<boolean>(false);

  
}